import { provideAnalytics } from '@angular/fire/analytics';
import { provideFirebaseApp } from '@angular/fire/app';
// import { initializeAppCheck, provideAppCheck, ReCaptchaEnterpriseProvider } from '@angular/fire/app-check';
import { initializeApp } from 'firebase/app';
import { getAnalytics } from "firebase/analytics";

// constants
import { Google } from 'constants';

const firebaseAppConfig = {
  apiKey: "AIzaSyCtlKTLud4Vb8fxQmqj1tf8n-YZ1__C5Ic",
  authDomain: "sideline-apps.firebaseapp.com",
  databaseURL: "https://sideline-apps.firebaseio.com",
  projectId: "sideline-apps",
  storageBucket: "sideline-apps.firebasestorage.app",
  messagingSenderId: "171084083020",
  appId: "1:171084083020:web:91d34a1fa58ef3af0429e9",
  measurementId: "G-ZVDQ8D448C"
};

// const firebaseAppCheckConfig = {
//   provider: new ReCaptchaEnterpriseProvider(Google.RECAPTCHA),
//   isTokenAutoRefreshEnabled: true,
// }

const app = initializeApp(firebaseAppConfig);
const analytics = getAnalytics(app);
// const appCheck = initializeAppCheck(app, firebaseAppCheckConfig)

const provideFirebaseApplication = provideFirebaseApp(() => app);
const provideFirebaseAnalytics = provideAnalytics(() => analytics);
// const provideFirebaseAppCheck = provideAppCheck(() => appCheck);

export {
  app,
  analytics,
  // appCheck,
  provideFirebaseApplication,
  provideFirebaseAnalytics,
  // provideFirebaseAppCheck,
};
